export default {
    activeChat(state) {
        return state.activeChat;
    },
    typing(state) {
        return state.typing;
    },
    messages(state) {
        return state.messages[state.activeChat.user_id];
    }
}